import { render, staticRenderFns } from "./EstratoFlorestal.vue?vue&type=template&id=0acfa42c&scoped=true"
import script from "./EstratoFlorestal.vue?vue&type=script&lang=js"
export * from "./EstratoFlorestal.vue?vue&type=script&lang=js"
import style0 from "../../../../css/crud.css?vue&type=style&index=0&id=0acfa42c&prod&scoped=true&lang=css&external"
import style1 from "./EstratoFlorestal.vue?vue&type=style&index=1&id=0acfa42c&prod&scoped=true&lang=css"
import style2 from "./EstratoFlorestal.vue?vue&type=style&index=2&id=0acfa42c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acfa42c",
  null
  
)

export default component.exports